import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

export const purchaseSeatLanguages = {
  progressBarText:
    "Add up to 5 games for max savings! 2 games at $15 tickets, 3 games at $14 tickets, 4 games at $13 tickets or 5 games at $12 tickets!",
  progressBarAditionalText: " to continue!",
};

export const TryCityDustDevilsLink = () => (
  <Link
    target="_blank"
    sx={{
      fontWeight: 500,
      color: "primary.main",
      textDecoration: "none",
    }}
    href="https://mlb.tickets.com/?agency=MILB_MPV&orgid=57349#/auth/login?fullret=%2Fschedule%2F%3Fagency%3DMILB_MPV%26orgid%3D57349%23%2F%3Fview%3Dlist%26includePackages%3Dtrue0"
  >
    MyTickets
  </Link>
);

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to MLB.com",
    description:
      "Click Continue and connect your Tri-City Dust Devils account using our secure MLB.com login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your <TryCityDustDevilsLink /> account
        within 24 hours of purchase. Reach out to Live Fan Support for any
        questions.
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How does the Dust Devils Buy More Save More Plan work?",
    description:
      "The Dust Devils Buy More Save More Plan allows fans to up to 5 games for max savings on tickets! Simply log into your MLB.com to get started.",
  },
  {
    title: "Do I have to select all my games at once?",
    description: "Yes, you must select all your games at once.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all currently available inventory.",
  },
  {
    title: "Where are my tickets delivered?",
    description: (
      <>
        Tickets will be available in your Dust Devils <TryCityDustDevilsLink />{" "}
        Account within 24 hours.
      </>
    ),
  },
];
